import {FormFieldValidationMessage, FormFieldValidationMessageProps, Pane} from 'evergreen-ui';
import React from 'react';
import {FieldError} from 'react-hook-form';

type ValidationMessageProps = {
    error?: FieldError;
} & FormFieldValidationMessageProps;
export const ValidationMessage = ({error, ...rest}: ValidationMessageProps) => {
    return (!!error?.message) ?
        <FormFieldValidationMessage marginTop={8} {...rest}>
            <Pane is='span' color='#ec4c47'>{error.message}</Pane>
        </FormFieldValidationMessage> : null ?? null;
}
